import React from 'react';
import FileUploadServices from '../components/services/FileUploadServices';

const Services = () => {
  return (
    <div className="space-y-5">
      <h1 className="text-2xl md:text-3xl font-semibold tracking-tight text-gray-900">Service Categories</h1>

      <FileUploadServices />
    </div>
  );
};

export default Services;
